import { ForwardOutlined } from '@mui/icons-material';

import { useState } from 'react';

import { Or2Button } from '@/components/button/Or2Button';
import { Or2LinkButton } from '@/components/button/Or2LinkButton';
import { graphql, type DocumentType } from '@/gql';

import { useGetFileUrl } from '@/modules/files/hooks/useGetFileUrl';

import { FileShareOnNoticeboardDialog } from './FileShareOnNoticeboardDialog';

const FILE_SHARE_ON_NOTICEBOARD_BUTTON_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment fileShareOnNoticeboardButtonFilesForOwnerFields on FilesForOwner {
    parent {
      _id
      filename
      url
    }
    owner {
      ... on Group {
        _id
        machineName
      }
      ... on Service {
        _id
        machineName
      }
    }
  }
`);

interface Props {
  filesForOwner: DocumentType<
    typeof FILE_SHARE_ON_NOTICEBOARD_BUTTON_FILES_FOR_OWNER_FRAGMENT
  >;
}

export const FileShareOnNoticeboardButton = ({ filesForOwner }: Props) => {
  const { parent: file, owner } = filesForOwner;
  const { machineName } = owner ?? {};
  const { filename } = file ?? {};

  const [dialogOpen, setDialogOpen] = useState(false);
  const getFileUrl = useGetFileUrl({
    type: 'Group',
    machineName: machineName ?? '',
  });

  const searchParams = new URLSearchParams();

  searchParams.set('prefillTitle', filename ?? '');
  searchParams.set('prefillHref', file ? getFileUrl(file) : '');

  if (owner.__typename === 'Group') {
    return (
      <Or2LinkButton
        href={`/g/${machineName}/noticeboard?${searchParams.toString()}`}
        startIcon={<ForwardOutlined />}
      >
        Share
      </Or2LinkButton>
    );
  }

  return (
    <>
      <Or2Button
        startIcon={<ForwardOutlined />}
        onClick={() => setDialogOpen(false)}
      >
        Share
      </Or2Button>
      <FileShareOnNoticeboardDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
